import awsconfig from './aws-exports/aws-exports.prod';

export const environment = {
  production: false,
  awsconfig,
  analytics: {
    enabled: true,
    token: 'phc_vMp5qGz6Sx2LhsNWTZLWs3xW6WipatQCCBu64DejuG7B',
    host: 'https://eu.i.posthog.com',
    environment: 'production',
    allowedHosts: ['register.app.casenoter.com'],
  },
};

export const CASENOTER_DOWNLOAD_URL =
  'https://download.casenoter.com/prod/latest';
export const REGISTRATION_URL = 'https://register.app.casenoter.com';
export const S3_BUCKET_ID = 'casenoter-app-v2-builds';
export const FREE_TRIAL_PRODUCT_ID = 'prod_O8Jmv66WbAee2O';
